module.exports = __webpack_public_path__ + "static/media/historial.bbec71ee.svg";